import {Component, h, Host} from '@stencil/core';

@Component({
  tag: 'nest-shell-navigation',
  styleUrl: 'nest-shell-navigation.scss',
  shadow: true,
})
export class NestShellNavigation {
  render() {
    return (
      <Host>
        <div class="nest-shell-navigation">
          <div class='flex justify-between items-center p-4'>
            <div>
              <slot name='shell-navigation-logo' />
            </div>
            <div class='flex items-center'>
              <slot name='shell-navigation-end'/>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
